import React from 'react';
import { Alert } from 'react-bootstrap';

/**
 * @param {{ warnings: Array<{ severity?: string, message: string, field?: string }> }} props
 */
const ExtractionWarnings = ({ warnings = [] }) => {
  if (!warnings.length) return null;

  return (
    <div className="mb-3">
      {warnings.map((w, idx) => {
        const variant =
          w.severity === 'error'
            ? 'danger'
            : w.severity === 'info'
              ? 'info'
              : 'warning';
        return (
          <Alert key={`${w.field || 'w'}-${idx}`} variant={variant} className="py-2 small mb-2">
            {w.message}
          </Alert>
        );
      })}
    </div>
  );
};

export default ExtractionWarnings;
